import { useNavigate } from "react-router-dom";
const CountryNavbar = ({ selectedCountry }) => {
  const navigate = useNavigate();

  const handleChangeDestination = () => {
    try {
      localStorage.removeItem("destination");
      window.dispatchEvent(new Event("storageUpdate")); // notify App
    } catch (error) {
      console.error("Error removing destination:", error);
    }
    navigate("/");
  };
  return (
    <div className="w-full bg-white shadow-md px-6 -mb-[1.3rem] z-20 ">
      <div className="max-w-7xl mx-auto flex justify-end items-center ">
        <div className="flex items-center space-x-4 floating-Dock rounded-b-2xl xs:rounded-bl-2xl xs:rounded-br-[4px] px-1">
          <div className="flex items-center px-4">
            <button
              onClick={handleChangeDestination}
              className=" text-white hover:text-blue-400 transition-colors  my-2 rounded-full text-xs font-medium flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 mr-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
              Change Destination
            </button>
            <span className="text-[10px] xs:text-xs font-medium ms-2 text-blue-700 bg-white py-[1px] px-2 rounded-full">
              <span className="font-semibold capitalize">
                {selectedCountry}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryNavbar;
